var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.15 3c0-.47.38-.85.85-.85h2a.85.85 0 0 1 .834.683l.263 1.317H21a.85.85 0 0 1 .76 1.23l-4 8a.85.85 0 0 1-.76.47H7.352l-2.044 2.044a.14.14 0 0 0-.044.076.16.16 0 0 0 .012.087.16.16 0 0 0 .053.07c.016.011.04.023.085.023H17a2.85 2.85 0 1 1-2.608 1.7H9.608a2.85 2.85 0 1 1-5.102-.231c-.996-.559-1.324-2.003-.4-2.927l1.971-1.971L4.303 3.85H3A.85.85 0 0 1 2.15 3m5.547 9.15h8.778l3.15-6.3H6.437zM7 17.85a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3m10 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3",
  clipRule: "evenodd"
})));
export default SvgShoppingCart;